import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Aboutus from '../components/Aboutus/Aboutus';
import Footer from '../components/Footer/Footer';
import Pagetop from '../components/Pagetop/Pagetop';
import Service from '../components/Service/Service';

class Aboutuspage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="About Us" />
                <Pagetop title="About Us" />
                {/* <Topbanner/> */}
                <Aboutus/>
                <Service/>
                <Footer/>
                
            </div>
        );
    }
}

export default Aboutuspage;